<template>
    <div>
        <template v-if="!type">
            <div class="hero hero__autoheight hero--toplist">
                <div class="hero__card hero__card--full">
                    <div class="hero__card-inner">
                        <div class="hero__content">
                            <div class="hero__content--inner">
                                <h1 class="hero__header">Topplister</h1>
                                <div class="hero__menu">
                                    <div class="hero__menuitems">
                                        <div class="hero__menuitem" v-for="entry in toplists" :key="entry.type">
                                            <a href="#" class="action" @click.prevent="navigate(entry.type)">
                                                <i class="pi" :class="iconFor(entry.type)"></i>
                                                {{ entry.title }}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="hero__bottom">
                <div class="hero__bottom--inner">
                    <div class="hero__info-text" v-if="competitionName">{{ competitionName }}</div>
                    <div class="hero__stats">
                        <div class="hero__stat">
                            <div class="hero__statcount hero__statcount--neutral">{{ regFormat(registrations) }}</div>
                            <div class="hero__stat-text">Registreringer</div>
                        </div>
                        <div class="hero__stat">
                            <div class="hero__statcount hero__statcount--neutral">{{ regFormat(users) }}</div>
                            <div class="hero__stat-text">Personer</div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <ToplistRegistrations
            v-else-if="type === 'registrations' || type === 'marathon'"
            :key="type"
            :variation="type"
            :competition-id="competitionId"
            :person-id="personId"
            @back="goBack"
        />
        <ToplistCounties v-else-if="type === 'counties'" :competition-id="competitionId" @back="goBack" />
        <ToplistCompanies v-else-if="type === 'companies'" :competition-id="competitionId" @back="goBack" />
        <ToplistRoutes v-else-if="type === 'routes'" :competition-id="competitionId" @back="goBack" />
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { regFormat } from '../config/format.js';
import ToplistRegistrations from './ToplistRegistrations.vue';
import ToplistCounties from './ToplistCounties.vue';
import ToplistCompanies from './ToplistCompanies.vue';
import ToplistRoutes from './ToplistRoutes.vue';

const props = defineProps({
    competitionId: { type: Number, default: null },
    competitionName: { type: String, default: '' },
    personId: { type: Number, default: null },
    toplists: { type: Array, default: () => [] },
    registrations: { type: Number, default: 0 },
    users: { type: Number, default: 0 },
});

function typeFromUrl() {
    return new URLSearchParams(window.location.search).get('type') || null;
}

// Mirrors the icon choices already used elsewhere for the same concepts -
// pi-map/pi-building match the admin sidebar's Turer/Bedrifter icons,
// pi-building also matches mypage.blade.php's own company links.
const ICONS = {
    registrations: 'pi-users',
    marathon: 'pi-users',
    routes: 'pi-map',
    counties: 'pi-globe',
    companies: 'pi-building',
};

function iconFor(toplistType) {
    return ICONS[toplistType] || 'pi-list';
}

const type = ref(typeFromUrl());

// replaceState, not pushState: every sub-view's own filter changes
// (competition, order, page, ...) already use replaceState and never add a
// history entry of their own - if entering the type here pushed one, a
// single back-navigation from anywhere inside the sub-view (an accidental
// trackpad/mouse-button/mobile back gesture, not just the in-app "Tilbake"
// link) would jump straight past all of that filter state to this one
// pushed entry's predecessor, i.e. the bare pre-type-selection /topplister,
// which looks like the whole view "reset" to the type selector.
function navigate(nextType) {
    type.value = nextType;
    history.replaceState({}, '', '/topplister?type=' + encodeURIComponent(nextType));
}

function goBack() {
    type.value = null;
    history.pushState({}, '', '/topplister');
}

function onPopState() {
    type.value = typeFromUrl();
}

onMounted(() => window.addEventListener('popstate', onPopState));
onUnmounted(() => window.removeEventListener('popstate', onPopState));
</script>
